/*
 *
 * BiometricDialog
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 01-Apr-2025
*/

import BiometricDialog from './BiometricDialogContainer'

export default BiometricDialog
